const theme = {
  grid: {
    gutterWidth: "20px",
  },
  fontFamily: {
    primary:
      '"SF Pro Display", "galano", "Helvetica", "SF Pro Text", -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
    secondary:
      '"Helvetica", "SF Pro Text", -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
  },
  transition: {
    default: "0.2s ease-in-out",
  },
  textSize: {
    size: {
      tiny: "9px",
      caption: "10px",
      caption1: "11px",
      caption2: "12px",
      caption3: "22px",
      caption4: "26px",
      paragraph: "16px",
      paragraph2: "16px",
      paragraph3: "20px",
      subheader1: "16px",
      subheader2: "19px",
      subheader3: "28px",
      subheader4: "25px",
      subheader5: "18px",
      subheader6: "20px",
      title1: "24px",
      title2: "28px",
      title3: "26px",
      display1: "32px",
      display2: "36px",
      display3: "44px",
      display4: "46px",
      display5: "36px",
      display6: "40px",
      heading1: "36px",
      heading2: "22px",
      heading3: "18px",
      heading4: "16px",
      blogText: "18px",
      text1: "16px",
    },
    height: {
      tiny: "11px",
      caption: "14px",
      caption1: "13px",
      caption2: "14px",
      caption3: "32px",
      caption4: "29px",
      paragraph: "28px",
      paragraph2: "22px",
      paragraph3: "28px",
      subheader1: "24px",
      subheader2: "27px",
      subheader3: "40px",
      subheader4: "32px",
      subheader5: "34px",
      subheader6: "27px",
      title1: "32px",
      title2: "34px",
      title3: "38px",
      display1: "48px",
      display2: "52px",
      display3: "52px",
      display4: "46px",
      display5: "48px",
      display6: "42px",
      heading1: "48px",
      heading2: "28px",
      heading3: "27px",
      heading4: "24px",
      blogText: "34px",
      text1: "28px",
    },
  },
  colors: {
    primary: "#FFB917",
    primary700: "#FCB000",
    primary800: "#F5CF79",
    primary900: "#E98807",
    gray700: "#A6A6A6",
    gray600: "#6C6C6C",
    gray500: "#787878",
    gray400: "#EAEAEA",
    gray300: "#979797",
    gray200: "#F4F4F4",
    gray450: "#D8D8D8",
    black50: "rgba(0, 0, 0, 0.5)",
    black300: "#0E0E0E",
    black500: "#4A4A4A",
    black550: "#404040",
    black600: "#393939",
    black700: "#252525",
    black800: "#131313",
    blueGray: "#7295B7",
    blueGray1: "#B2BACB",
    yellowGray: "#B58518",
    pinkGray: "#B7729D",
    border: "#272727",
    red: "#3B1414",
    error: "#d00505",
    success: "#239c65",
    peachGray: "#D8C4B0",
    lightGray: "#D1D1D1",
    darkGray: "#9297A3",
    blackGray: "#252525",
    lightBlack: "#191C21",

    gradient: "linear-gradient(right, #a66644, #e29e6c, #c77b53)",
    gradient2: "linear-gradient(to right, #fff, #F5CF79)",
  },
  shadows: {
    1: "0 8px 12px -1px rgba(0,0,0,0.16)",
    2: "0 12px 16px -1px rgba(0,0,0,0.16)",
    3: "0 2px 4px 0 rgba(0,0,0,0.23)",
    modalShadow: "-20px 22px 23px 0 rgba(0,0,0,0.19)",
    primary: "5px 6px 0 0 rgb(233, 136, 7)",
  },
};

export default theme;
